import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../../hooks/useAdmin';
import { BurgerMenu } from './BurgerMenu';
import './CustomerNavbar.css';

export default function CustomerNavbar() {
  const navigate = useNavigate();
  const { displayName } = useAdmin();

  return (
    <nav className="customer-navbar">
      <div className="customer-navbar-brand" onClick={() => navigate('/customer')} style={{ cursor: 'pointer' }}>
        <span>Pest<strong>Connect</strong> <em>LIVE</em></span>
      </div>
      <div className="customer-navbar-right">
        {displayName && <span className="customer-navbar-username">{displayName}</span>}
        <BurgerMenu currentPage="customer" />
      </div>
    </nav>
  );
}
